import isIPad from "./isIPad";

export default () => {
    const viewportHeight = 760;

    if (window.innerHeight <= viewportHeight && !isIPad()) {
      document.body.classList.add('small-height');
    } else {
      document.body.classList.remove('small-height');
    }

}